// @flow
import * as React from 'react';

export default React.createContext<{ isScrolling: boolean }>({ isScrolling: false });
